import {isNumber} from '@shared/helpers/lang'

import makeSlice from '@web/slices/banner/sliceMaker'
import {initDeliveryTracking} from '@web/slices/deliveryTracking/slice'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDeliveryTracking.fulfilled, (state, {payload}) => {
            const orderDelivery = payload.orderDelivery
            state.fuc = [
                {
                    service: 'order',
                    page: 'deliveryTracking',
                    area: 'deliveryTracking_1',
                    ...(orderDelivery?.productOrder.largeCategoryId && {
                        'custom.largeProductCategory': orderDelivery?.productOrder.largeCategoryId,
                    }),
                    ...(orderDelivery?.productOrder.middleCategoryId && {
                        'custom.middleProductCategory': orderDelivery?.productOrder.middleCategoryId,
                    }),
                    ...(orderDelivery?.productOrder.smallCategoryId && {
                        'custom.smallProductCategory': orderDelivery?.productOrder.smallCategoryId,
                    }),
                    ...(isNumber(orderDelivery?.productOrder.orderAmount) && {
                        'custom.totalInitPayAmount': orderDelivery?.productOrder.orderAmount.toString(),
                    }),
                    ...(orderDelivery?.generalPayMeansClassType && {
                        'custom.generalPayMeansClassType': orderDelivery?.generalPayMeansClassType,
                    }),
                    ...(orderDelivery?.productOrder.saleChannelType && {
                        'custom.saleChannelType': orderDelivery?.productOrder.saleChannelType,
                    }),
                },
            ]
        })
    },
})

export default slice.reducer
